
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import BoundsMarker from "../../editor/BoundsMarker";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleStartChunk extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -54, 847);
    this.add(trunk_png_2);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 458, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // platformMarkerFoliage4
    const platformMarkerFoliage4 = new PlatformMarkerFoliage4(scene, -53, 530);
    this.add(platformMarkerFoliage4);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 82, 429);
    this.add(gemMarker_11);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -199, 460);
    this.add(checkpointMarker);

    // this (components)
    new ChunkBoundaries(this);
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
